import React from 'react'
import { Container } from 'reactstrap'
import Breadcrumb from '../../components/Common/Breadcrumb'

function ManageSorce() {
  return (
    <div className='page-content'>
        <Container fluid>
            <Breadcrumb title="blank" breadcrumbItem="blank" />
            BlackPage
        </Container>
        
    </div>
  )
}

export default ManageSorce